import { AST } from '@handlebars/parser';
import { createContentStatement } from 'modules/handlebars/domain/statement/utils';
import { StatementSerializer } from 'modules/handlebars/domain/statement/serializer';
import { ExpressionSerializer } from 'modules/handlebars/domain/expression/serializer';
import { getPathFromMustacheStatement } from 'modules/dynamicContentBuilder/utils';
import { removeScript } from 'utils/script';
import mergeTagIcon from '../assets/profileField.png';
import { createHandlebarsToken } from './createHandlebarsToken';

export const createMergeTagTokenForMustacheStatement = (statement: AST.MustacheStatement) => {
  const underlyingHandlebarString = StatementSerializer.serialize(statement);
  const path = getPathFromMustacheStatement(statement);
  const fieldName = path ? ExpressionSerializer.serialize(path) : '';
  const escapedFieldName = removeScript(fieldName);
  const token = createHandlebarsToken(escapedFieldName, underlyingHandlebarString, mergeTagIcon);
  return createContentStatement(token);
};
